<!-- #63 -->
<template>
  <v-col class="mx-3">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        Add/Edit Projection
      </div>

      <v-spacer> </v-spacer>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>

    <v-card>
      <v-card-title>
        <span class="body-1 font-weight-bold"
          >Add/Edit

          <i class="caption red--text ml-4"> * required field</i>
        </span>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-form ref="form">
          <v-row>
            <v-col
              cols="12"
              sm="6"
              md="6"
              class="pb-0"
              v-if="this.$route.query.id > 0"
            >
              <v-text-field
                label="Warehouse"
                v-model="wms_warehouse_code"
                disabled
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" class="pb-0" v-else>
              <v-autocomplete
                label="Select Warehouse"
                :items="warehousees"
                v-model="wms_warehouse_code"
                :rules="[(v) => !!v || 'Warehouse is required.']"
                class="required pb-0"
                hide-details="auto"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="6"
              class="pb-0"
              v-if="this.$route.query.id > 0"
            >
              <v-text-field
                label="Storer"
                v-model="storer_name"
                disabled
                outlined
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="6"
              class="pb-0"
              v-if="this.$route.query.id > 0"
            >
              <v-text-field
                label="Projection Date"
                v-model="projection_date"
                disabled
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" class="pl-3 pb-0" v-else>
              <v-menu
                v-model="dateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
                @update:return-value="(val) => (date = val || date)"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="getFormattedDate(date)"
                    label="Projection Date"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    class="required pb-0"
                    :rules="[(v) => !!v || 'Please Select Projection Date']"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="date"
                  @input="dateMenu = false"
                  @click:date="$refs.dateMenu.save(date)"
                  :min="getStartDate"
                  :reactive="false"
                  v-if="dateMenu"
                  hide-details="auto"
                  :initial-active-month="() => new Date()"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col md="6" class="custom pb-0" v-if="!this.$route.query.id">
              <v-file-input
                v-model="file"
                counter
                show-size
                accept=".xlsx"
                class="required"
                prepend-icon=""
                prepend-inner-icon="mdi-paperclip"
                label="Upload Your Projection File"
                outlined
                :rules="[(v) => !!v || 'Please Upload Projection File']"
              >
              </v-file-input>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="6"
              class="pb-0"
              v-if="this.$route.query.id > 0"
            >
              <v-autocomplete
                :items="purposes"
                outlined
                v-model="purpose"
                disabled
                label="Type"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" v-if="this.$route.query.id > 0">
              <v-autocomplete
                :items="vehicles"
                outlined
                v-model="vehicle_type"
                label="Vehicle Type"
                class="required pb-0"
                disabled
                :rules="[(v) => !!v || 'Vehicle Type is required.']"
              ></v-autocomplete>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="6"
              class="pb-0"
              v-if="this.$route.query.id > 0"
            >
              <v-text-field
                label="Vehicle Number"
                v-model="no_of_vehicle"
                outlined
                class="required pb-0"
                :rules="[(v) => !!v || 'Vehicle Number is required.']"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="6"
              class="pb-0 pt-0"
              v-if="this.$route.query.id > 0"
            >
              <v-text-field
                label="Quantity"
                v-model="quantity"
                outlined
                class="required pb-0"
              ></v-text-field>
            </v-col>

            <v-col
              cols="12"
              sm="6"
              md="6"
              class="pb-0 pt-0"
              v-if="this.$route.query.id > 0"
            >
              <v-text-field
                label="Pallet Number"
                v-model="pallet_number"
                outlined
                class="required pb-0"
                :rules="[(v) => !!v || 'Pallet Number is required.']"
              ></v-text-field>
            </v-col>

            <v-col
              cols="12"
              sm="6"
              md="6"
              class="pb-0"
              v-if="this.$route.query.id > 0"
            >
              <v-autocomplete
                :items="statuses"
                outlined
                v-model="status"
                label="Status"
                item-text="text"
                item-value="value"
                class="required pb-0"
                :rules="[(v) => v !== null || 'Status is required.']"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row class="text-left mt-0">
            <v-col class="">
              <v-btn color="primary" dark :loading="fileLoader" @click="save">
                Add/Edit
              </v-btn>
              <v-btn
                color="info"
                class="ml-3"
                :loading="downloader"
                @click="downloadTemplate()"
                v-if="!editable"
                >Download Template
              </v-btn>

              <v-btn class="ml-3" @click="close()"> Cancel </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
    <BulkErrors
      :dialog="uploadResDialog"
      :data="uploadRes"
      @close="uploadResDialog = false"
      file-name="Projection-Errorlist"
      :other="other"
    />
  </v-col>
</template>
<script>
import { mapActions } from "vuex";
import BulkErrors from "@/components/front/common/BulkErrors";

export default {
  components: {
    BulkErrors,
  },
  data: () => ({
    statuses: [
      { text: "Active", value: 1 },
      { text: "Inactive", value: 0 },
    ],
    status: null,
    uploadRes: {},
    uploadResDialog: false,
    deliveryDate: false,
    fileLoader: false,
    reasonList: "",
    required: false,
    tokenDetails: {},
    warehousees: [],
    dateMenu: false,
    date: null,
    file: null,
    wms_warehouse_code: null,
    pallet_number: null,
    quantity: null,
    storers: [],
    vehicles: [],
    storer_name: null,
    purposes: [
      {
        text: "Inbound",
        value: 1,
      },
      {
        text: "Outbound",
        value: 2,
      },
      {
        text: "Both",
        value: 3,
      },
    ],
    no_of_vehicle: null,
    vehicle_type: null,
    purpose: null,
    editable: false,
  }),

  async created() {
    if (this.$route.query.id > 0) {
      this.editable = true;
    } else {
      this.editable = false;
    }
    await this.fetchStore();
    if (this.$route.query.id > 0) {
      this.getProjectionDetails(this.$route.query.id).then((res) => {
        this.wms_warehouse_code = res.data[0].actual_warehouse;
        this.projection_date = res.data[0].projection_date;
        this.quantity = res.data[0].quantity;
        this.pallet_number = res.data[0].pallet_number;
        this.vehicle_type = res.data[0].vehicle_type;
        this.no_of_vehicle = res.data[0].no_of_vehicle;
        this.storer_name = res.data[0].storer_name;
        this.status = res.data[0].status;
        const selectedPurpose = this.purposes.find(
          (purpose) => purpose.text === res.data[0].type
        );
        this.purpose = selectedPurpose ? selectedPurpose.value : null;
      });
    }
  },
  computed: {
    getEndDate() {
      var endDate = new Date();
      endDate.setDate(endDate.getDate());
      endDate.setHours(0, 0, 0, 0); // Set hours, minutes, seconds, and milliseconds to zero
      return endDate.toISOString().split("T")[0]; // Keep only the date part
    },
  },
  methods: {
    ...mapActions([
      "fetchStorelist",
      "downloadProjectionTemplate",
      "uploadProjection",
      "snackBar",
      "getProjectionDetails",
      "updateProjection",
    ]),
    async fetchStore() {
      await this.fetchStorelist().then((res) => {
        this.storers = res.data.storer;
        this.warehousees = res.data.warehouses.map(
          (obj) => Object.keys(obj)[0]
        );
        this.vehicles = res.data.vehicle_types;
      });
    },
    downloadTemplate() {
      this.downloader = true;
      let url = `/api/file_download?file_path=app_pas/pas_templates/pas_projection_template.xlsx`;
      this.downloadProjectionTemplate(url)
        .then((res) => {
          this.fileDownload(res);
          this.downloader = false;
        })
        .catch(() => {
          this.downloader = false;
        });
    },
    close() {
      this.$refs.form.reset();
      this.$router.go(-1);
    },
    save() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.fileLoader = true;
      const payload = new FormData();
      payload.append("projection_date", this.date);
      payload.append("warehouse_name", this.wms_warehouse_code);
      if (this.$route.query.id > 0) {
        let dataRequired = {
          type: this.purpose,
          quantity: this.quantity,
          pallet_number: this.pallet_number,
          no_of_vehicle: this.no_of_vehicle,
          vehicle_type: this.vehicle_type,
          status: this.status,
        };
        let payloaddata = {
          id: this.$route.query.id,
          data: dataRequired,
        };
        this.updateProjection(payloaddata)
          .then((res) => {
            this.fileLoader = false;

            this.$refs.form.reset();
            this.date = null;
            if (res.data.with_error) {
              this.uploadRes = res.data;
              this.uploadResDialog = true;
            } else {
              this.snackBar({
                color: "success",
                message: res.data.message,
              });
              this.$router.push("/pasProjectionList");
            }
          })
          .catch(() => {
            this.fileLoader = false;
          });
      } else {
        payload.append("data_file", this.file, this.file.name);

        this.uploadProjection(payload)
          .then((res) => {
            this.fileLoader = false;

            this.$refs.form.reset();
            this.date = null;
            if (res.data.with_error) {
              this.uploadRes = res.data;
              this.uploadResDialog = true;
            } else {
              this.snackBar({
                color: "success",
                message: res.data.message,
              });
              this.$router.push("/pasProjectionList");
            }
          })
          .catch(() => {
            this.fileLoader = false;
          });
      }
    },
  },
};
</script>
